import { Box, InputLabel } from '@mui/material';
import styled from 'styled-components';

export const StyleBox = styled(Box)`
  margin-bottom: 1.25rem;
  .MuiInputBase-root,
  .MuiOutlinedInput-root,
  .MuiSelect-select,
  .MuiInputBase-input {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    height: 2.5rem !important;
    min-height: 2.5rem !important;
    line-height: 2.5rem !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .MuiInputBase-root {
    border-radius: 5px !important;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: #d9d9d9 !important;
  }
  .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #fe2f67 !important;
    }
  }
  .SelectOptionsDropDown {
    color: red !important;
  }
  .MuiSelect-outlined {
    height: 2.5rem;
    min-height: 2.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    line-height: 2.5rem;
  }
  .MuiSelect-select:focus {
    color: #fe2f67 !important;
  }
  .Mui-focused .MuiSelect-select {
    color: #fe2f67 !important;
  }
  .MuiInputLabel-root.Mui-focused {
    color: #fe2f67 !important;
  }
`;
export const DropDownLabel = styled.p`
  font-size: 1.6vh;
  margin-bottom: 10px;
  color: #fe2f67;
`;

export const StyleInputLabel = styled(InputLabel)`
  &.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {
    font-size: 1.5vh;
    transform: none;
    padding: 0 1.2rem;
    color: #8692a6;
    line-height: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
  }

  &.css-1sumxir-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {
    font-size: 1.5vh;
    transform: none;
    padding: 0 1.2rem;
    color: #fe2f67;
    line-height: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
  }

  &.MuiInputLabel-shrink {
    color: #fe2f67 !important;
    /* font-weight: 600; */
    padding: 0 1.2rem;
    line-height: 1.2rem;
    height: auto;
    display: block;
    align-items: flex-start;
  }
  &.Mui-focused {
    color: #fe2f67 !important;
  }
`;
